import React, {
    Fragment,
    useEffect,
    useRef,
    useState
} from 'react';
import { ErrorMessageForModals } from "../components-shared/index";
import styled from "styled-components";
import { useLocation, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { landingpageSegments } from '../constants';
import { Loader } from "../components-shared/index";
import { sessionStorageHelper, getEnvironment } from "../utils/index";

const Iframe = styled.iframe`
    margin-bottom: 25px;
    width: 100%;
    height: 530px;

    ${props => props.theme.mediaQueries.medium}{
        height: 685px;
    }
`

const BookMeetingModal = () => {
    const [isSession, setIsSession] = useState(false)
    const [isError, setIsError] = useState(false)
    const [isMailError, setIsMailError] = useState(false)
    const [token, setToken] = useState()
    const ref = useRef(null);
    const location = useLocation();
    const history = useHistory();
    const queryString = useSelector(state => state.queryStringReducer.queryString)

    
    useEffect(() => {
        if (queryString) {
            sessionStorage.setItem('icCode', landingpageSegments[queryString].icCode)
        }
    },[])


    //handel postback refresh from backend to show background
    useEffect(() => {
        const locationSearch = sessionStorage.getItem('locationSearch')

        if (locationSearch && location.pathname === '/bookmeeting') {
            history.push({
                state: {
                    background: {
                        pathname: "/",
                        search: locationSearch
                    }
                }
            })
        }
    }, [])

    useEffect(() => {
        const checkForServerResponse = () => {

            //For dev server testing
            sessionStorage.setItem('outboundData', JSON.stringify(
                {
                    geckoToken: ''
                }
            ))


            sessionStorageHelper.getSessonStorageData('outboundData', 'geckoToken', location, history, (data) => {
                // 'error' is returned if the backend has sent a mail with error details and customer data to the service center
                // 'errorcaptcha' is returned if the captcha validation failed
                if (data === 'error') {
                    setIsMailError(true);
                } else if (data === 'errorcaptcha') {
                    setIsError(true);
                } else {
                    setIsSession(true);
                    setToken(data)
                }
            });
        }

        checkForServerResponse();

    }, [])

    const getIcCode = () => {
        const icCode = sessionStorage.getItem('icCode');

        if (icCode) {
            //sessionStorage.removeItem('icCode');
            return icCode;
        } else {
            setIsError(true);
        }
    }

    return (
        <Fragment>
            { isMailError ? <ErrorMessageForModals 
                            headerText='Noget gik galt' 
                            paragraphText='Vi har et teknisk problem. Dine oplysninger er sendt til en rådgiver, som kontakter dig hurtigst muligt.'
                        /> 
                : isError ? <ErrorMessageForModals /> 
                : !isSession
                    ? <Loader />
                    : <Iframe ref={ref} src={`https://app.geckobooking.dk/site/index.php?icCode=${getIcCode()}&dTpl=1&token=${token}`} frameBorder="0" allowFullScreen></Iframe>
            }
        </Fragment>
    )


}

export default BookMeetingModal;